module.exports = __webpack_public_path__ + "static/img/418.eb7ff66.png";